import { render, staticRenderFns } from "./article_mentions.vue?vue&type=template&id=4ef732b6"
import script from "./article_mentions.vue?vue&type=script&lang=js"
export * from "./article_mentions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports